import React from "react";
import Main from "./main";
function App() {
  return (
    <div>
     <Main/>
    </div>
  );
}

export default App;
